import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import {
  createAutoCorrectedDatePipe,
} from 'text-mask-addons';
import MaskedInput from 'react-text-mask';


import BaseInput from '../BaseInput';


const propTypes = {
  label: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  componentProps: PropTypes.object,
  ...fieldPropTypes,
};


const defaultProps = {
  componentProps: {},
};


const DateInput = (props) => {
  const {
    componentProps,
    label,
    input,
    meta,
  } = props;

  const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  const pipe = createAutoCorrectedDatePipe('mm dd yyyy');
  const placeholder = 'mm/dd/yyyy';

  return (
    <BaseInput
      label={label}
      input={input}
      meta={meta}
      componentClass={MaskedInput}
      componentProps={{
        guide: false,
        mask: dateMask,
        pipe,
        placeholder,
        ...componentProps,
      }}
    />
  );
};


DateInput.propTypes = propTypes;


DateInput.defaultProps = defaultProps;


export default DateInput;
